import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { basicService } from '@app/services';
import { IStep, TranslationsTypes } from '@app/models';
import { signOut } from '@app/store/actions';
import { PasslyButton } from '@app/components';

interface IProps {
    step: IStep;
}

interface IStepData {
    name: TranslationsTypes;
    desc: TranslationsTypes;
    button: TranslationsTypes;
}

const ChecklistItem: React.SFC<IProps> = ({ step }) => {

    const { translation } = useTypedTranslation();

    const checkClass = (completed: boolean) => {
        return completed ? 'tile__check tile__check--checked' : 'tile__check tile__check--unchecked';
    };

    const checkData = (step: IStep) => {
        const stepStart: IStepData = {
            name: step.nameStart,
            desc: step.descStart,
            button: step.buttonStart
        };

        const stepComplete: IStepData = {
            name: step.nameComplete,
            desc: step.descComplete,
            button: step.buttonComplete
        };

        return step.completed ? stepComplete : stepStart;
    };

    const stepData: IStepData = checkData(step);

    return (
        <div className='tile'>
            <div className={checkClass(step.completed)}>
                <i className='icon icon-check-circle'></i>
            </div>
            <div className='tile__content'>
                <h4 className='tile__content-header'>{translation(stepData.name)}</h4>
                <p className='tile__content-text' dangerouslySetInnerHTML={{__html: translation(stepData.desc)}}></p>
            </div>
            {stepData.button !== '' &&
                <div className='tile__action'>
                    {step.linkLocation !== '/signout' ? (
                        <PasslyButton variant='contained' color='primary' fullWidth onClick={() => { basicService.redirect(step.linkLocation); }}>
                            {translation(stepData.button)}
                        </PasslyButton>
                    ) : (
                        step.linkLocation === '/signout' &&
                        <PasslyButton variant='contained' color='primary' fullWidth onClick={() => signOut(false)}>
                            {translation(stepData.button)}
                        </PasslyButton>
                    )
                    }
                </div>
            }
        </div>
    );

};

export default ChecklistItem;
